import React, { useRef, useState, useEffect } from "react";
import {
  MdUpload,
  MdDelete,
  MdFormatAlignLeft,
  MdFormatAlignCenter,
  MdFormatAlignRight,
  MdExpandMore,
  MdExpandLess,
  MdCheckCircle,
  MdSave,
  MdEdit,
} from "react-icons/md"
import { IoClose } from "react-icons/io5"
import { FiType, FiGrid } from "react-icons/fi"
import { Modal, Button } from "react-bootstrap"
import { uploadFilesAWS, createBadge, UpdateBadge, GetTicketsByID } from "../../../api/Webservices"
import { useLocation, useHistory } from "react-router-dom"
import { showToast, ToastMessage } from "../../Shared/ToastMessage"

const DEFAULT_BACKGROUND_URL = "https://amasi.org/wp-content/uploads/2025/12/backgroudwhite.png"

function Badge() {
  const EventID = localStorage.getItem("eventId") || ""
  const history = useHistory()
  const location = useLocation()
  const badgeRef = useRef(null)
  const bgImageInputRef = useRef(null)
  const imageInputRef = useRef(null)
  
  const [step1Completed, setStep1Completed] = useState(false)
  const [isLocked, setIsLocked] = useState(false)
  const [isGenerating, setIsGenerating] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [badgeId, setBadgeId] = useState(null)
  const [bgFile, setBgFile] = useState(null)
  const [bgPreview, setBgPreview] = useState(null)
  const [backgroundUploadStatus, setBackgroundUploadStatus] = useState("idle")
  const [useDefaultBackground, setUseDefaultBackground] = useState(false)
  const [imageFiles, setImageFiles] = useState([])
  const [qrText, setQrText] = useState("https://example.com")
  const [qrImage, setQrImage] = useState(null)
  const [qrUrl, setQrUrl] = useState(null)
  const [qrPosition, setQrPosition] = useState({ x: 50, y: 50 })
  const [qrSize, setQrSize] = useState({ width: 80, height: 80 })
  const [isDragging, setIsDragging] = useState(false)
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 })
  const [draggingTextId, setDraggingTextId] = useState(null)
  const [draggingImageId, setDraggingImageId] = useState(null)
  const [resizingImageId, setResizingImageId] = useState(null)
  const [resizingQR, setResizingQR] = useState(false)
  const [resizingTextId, setResizingTextId] = useState(null)
  const [qrVisible, setQrVisible] = useState(false)
  const [badgeTitle, setBadgeTitle] = useState("New Badge Template")
  const [expandedFieldId, setExpandedFieldId] = useState(null)
  const [canvasSize, setCanvasSize] = useState("4x6")
  const [showHtmlModal, setShowHtmlModal] = useState(false)
  const [generatedHtml, setGeneratedHtml] = useState("")
  const [alertModal, setAlertModal] = useState({ show: false, message: "", variant: "info" })
  const [confirmModal, setConfirmModal] = useState({ show: false, message: "", onConfirm: null })
  const [isTicketDropdownOpen, setIsTicketDropdownOpen] = useState(false)
  const ticketDropdownRef = useRef(null)
const [bgAwsUrl, setBgAwsUrl] = useState(null)

  const handleConfirmModalConfirm = async () => {
    if (confirmModal.onConfirm) {
      try {
        await confirmModal.onConfirm()
      } catch (err) {
        console.error("Confirm action failed:", err)
      }
    }
    setConfirmModal({ show: false, message: "", onConfirm: null })
  }

  const [tickets, setTickets] = useState([])
  const [selectedTickets, setSelectedTickets] = useState([0])
  const [activeTab, setActiveTab] = useState("background")

  // Canvas size configuration with width and height
  const canvasSizes = {
    "4x6": { width: 384, height: 576, inchW: 4, inchH: 6 },
    "3x4": { width: 288, height: 384, inchW: 3, inchH: 4 },
    "4x4": { width: 384, height: 384, inchW: 4, inchH: 4 },
    "5x7": { width: 480, height: 672, inchW: 5, inchH: 7 },
  }

  const BADGE_WIDTH = canvasSizes[canvasSize].width
  const BADGE_HEIGHT = canvasSizes[canvasSize].height
  const BADGE_SIZE_INCHES = {
    w: canvasSizes[canvasSize].inchW,
    h: canvasSizes[canvasSize].inchH
  }

  const fontFamilies = [
    "Arial",
    "Helvetica",
    "Times New Roman",
    "Georgia",
    "Courier New",
    "Verdana",
    "Trebuchet MS",
    "Impact",
    "Comic Sans MS",
    "Palatino",
    "Garamond",
  ]

  const fontWeights = [
    { label: "Thin", value: "100" },
    { label: "Light", value: "300" },
    { label: "Regular", value: "400" },
    { label: "Medium", value: "500" },
    { label: "Semi Bold", value: "600" },
    { label: "Bold", value: "700" },
    { label: "Extra Bold", value: "800" },
    { label: "Black", value: "900" },
  ]

  const showPreviewElements = step1Completed
  const isStep2Enabled = step1Completed && !isLocked

  const [inputFields, setInputFields] = useState([
    {
      id: "attendee_name",
      label: "Attendee Name",
      placeholder: "ATTENDEE_NAME",
      fieldKey: "ATTENDEE_NAME",
      visible: false,
      x: 50,
      y: 100,
      width: 200,
      height: 50,
      fontSize: 16,
      fontFamily: "Arial",
      fontWeight: "700",
      color: "#000000",
      textAlign: "center",
    },
    {
      id: "email",
      label: "Email",
      placeholder: "EMAIL",
      fieldKey: "EMAIL",
      visible: false,
      x: 50,
      y: 150,
      width: 200,
      height: 30,
      fontSize: 16,
      fontFamily: "Arial",
      fontWeight: "400",
      color: "#333333",
      textAlign: "center",
    },
    {
      id: "organization",
      label: "Organization",
      placeholder: "ORGANIZATION",
      fieldKey: "ORGANIZATION",
      visible: false,
      x: 50,
      y: 200,
      width: 200,
      height: 30,
      fontSize: 16,
      fontFamily: "Arial",
      fontWeight: "500",
      color: "#333333",
      textAlign: "center",
    },
    {
      id: "event_name",
      label: "Event Name",
      placeholder: "EVENT_NAME",
      fieldKey: "EVENT_NAME",
      visible: false,
      x: 50,
      y: 50,
      width: 200,
      height: 50,
      fontSize: 16,
      fontFamily: "Arial",
      fontWeight: "800",
      color: "#000000",
      textAlign: "center",
    },
    {
      id: "venue",
      label: "Venue",
      placeholder: "VENUE",
      fieldKey: "VENUE",
      visible: false,
      x: 50,
      y: 250,
      width: 200,
      height: 30,
      fontSize: 16,
      fontFamily: "Arial",
      fontWeight: "400",
      color: "#333333",
      textAlign: "center",
    },
    {
      id: "event_date",
      label: "Event Date",
      placeholder: "EVENT_DATE",
      fieldKey: "EVENT_DATE",
      visible: false,
      x: 50,
      y: 280,
      width: 200,
      height: 30,
      fontSize: 16,
      fontFamily: "Arial",
      fontWeight: "600",
      color: "#333333",
      textAlign: "center",
    },
    {
      id: "ticket_type",
      label: "Ticket Type",
      placeholder: "TICKET_TYPE",
      fieldKey: "TICKET_TYPE",
      visible: false,
      x: 50,
      y: 320,
      width: 200,
      height: 30,
      fontSize: 16,
      fontFamily: "Arial",
      fontWeight: "500",
      color: "#333333",
      textAlign: "center",
    },
    {
      id: "registration_number",
      label: "Registration Number",
      placeholder: "REGISTRATION_NUMBER",
      fieldKey: "REGISTRATION_NUMBER",
      visible: false,
      x: 50,
      y: 360,
      width: 200,
      height: 30,
      fontSize: 16,
      fontFamily: "Courier New",
      fontWeight: "700",
      color: "#000000",
      textAlign: "center",
    },
  ])

  const [selectedFieldId, setSelectedFieldId] = useState(null)
  const selectedField = inputFields.find((f) => f.id === selectedFieldId)

  const showAlert = (message, variant = "info") => {
    setAlertModal({ show: true, message, variant })
  }

  const showConfirm = (message, onConfirm) => {
    setConfirmModal({ show: true, message, onConfirm })
  }
const handleBgImageUpload = async (file) => {
  try {
    // Show preview locally (for immediate feedback)
    const reader = new FileReader()
    reader.onload = (e) => setBgPreview(e.target.result)
    reader.readAsDataURL(file)
    
    // Upload to AWS
    const uploadResponse = await uploadFilesAWS([file])
    const uploadedUrls = uploadResponse?.data?.uploadedUrls || uploadResponse?.uploadedUrls || {}
    const bgUrl = Object.values(uploadedUrls).flat()[0]
    
    if (bgUrl) {
      setBgAwsUrl(bgUrl) // Store AWS URL - THIS IS WHAT WILL BE USED IN HTML
      console.log("[v0] Background AWS URL:", bgUrl)
    } else {
      throw new Error("Failed to get background AWS URL")
    }
  } catch (err) {
    console.error("Background upload failed:", err)
    throw err
  }
}
  const addCustomField = () => {
    if (isLocked) return
    const customCount = inputFields.filter((f) => !f.fieldKey).length + 1
    const newId = `custom_${Date.now()}`
    const newField = {
      id: newId,
      label: `Custom Text ${customCount}`,
      text: "Enter custom text",
      visible: true,
      x: 50,
      y: 100,
      width: 200,
      height: 30,
      fontSize: 16,
      fontFamily: "Arial",
      fontWeight: "400",
      color: "#000000",
      textAlign: "center",
    }
    setInputFields((prev) => [...prev, newField])
    setSelectedFieldId(newId)
    setExpandedFieldId(newId)
  }

  const deleteCustomField = (id) => {
    if (isLocked) return
    setInputFields((prev) => prev.filter((f) => f.id !== id))
    if (selectedFieldId === id) setSelectedFieldId(null)
    if (expandedFieldId === id) setExpandedFieldId(null)
  }

  const toggleFieldVisibility = (id) => {
    if (isLocked) return
    setInputFields((prev) => prev.map((field) => (field.id === id ? { ...field, visible: !field.visible } : field)))
    const field = inputFields.find((f) => f.id === id)
    if (!field.visible) {
      setSelectedFieldId(id)
      setExpandedFieldId(id)
    }
  }

  const updateField = (id, updates) => {
    if (isLocked) return
    setInputFields((prev) => prev.map((field) => (field.id === id ? { ...field, ...updates } : field)))
  }

  const deleteImage = (id) => {
    if (isLocked) return
    setImageFiles((prev) => prev.filter((img) => img.id !== id))
  }

  const handleClearAllImages = () => {
    if (isLocked) return
    showConfirm("Are you sure you want to remove all uploaded images?", () => {
      setImageFiles([])
      if (imageInputRef.current) {
        imageInputRef.current.value = ""
      }
    })
  }
  const handleBgImageChange = async (e) => {
  if (isLocked || (!isEdit && step1Completed)) return
  
  const file = e.target.files?.[0]
  if (!file) return
  
  setBackgroundUploadStatus("loading")
  
  try {
    setBgFile(file)
    
    // Call the upload handler to get AWS URL
    await handleBgImageUpload(file)
    
    // Set success status after AWS upload
    setBackgroundUploadStatus("success")
    setUseDefaultBackground(false)
  } catch (err) {
    console.error("Background upload error:", err)
    setBackgroundUploadStatus("error")
    showAlert("Failed to upload background image", "danger")
  }
}
const parseTemplate = (template) => {
    console.log(template, "parsing template...")
    if (!template || typeof template !== "string") {
      console.error("Invalid template")
      return
    }
    try {
      const parser = new DOMParser()
      const doc = parser.parseFromString(template, "text/html")
      const badgeEl = doc.querySelector(".badge")
      if (!badgeEl) {
        console.error(".badge element not found in template")
        return
      }
      const styleTag = doc.querySelector("style")
      if (styleTag) {
        const css = styleTag.textContent;
        const bgMatch = css.match(/background.*?url\(['"]?([^'"]+)['"]?\)/);
        if (bgMatch?.[1]) {
          console.log("Background URL found:", bgMatch[1])
          setBgPreview(bgMatch[1])
          setStep1Completed(true)
        }
        const qrLeftMatch = css.match(/\.qr\s*\{[^}]*left:\s*(\d+)px/);
        const qrTopMatch = css.match(/\.qr\s*\{[^}]*top:\s*(\d+)px/);
        const qrWidthMatch = css.match(/\.qr\s*\{[^}]*width:\s*(\d+)px/);
        const qrHeightMatch = css.match(/\.qr\s*\{[^}]*height:\s*(\d+)px/);
        const left = qrLeftMatch ? qrLeftMatch[1] : null;
        const top = qrTopMatch ? qrTopMatch[1] : null;
        const width = qrWidthMatch ? qrWidthMatch[1] : null;
        const height = qrHeightMatch ? qrHeightMatch[1] : null;
        if (left && top && width && height) {
          setQrPosition({ x: parseInt(left), y: parseInt(top) })
          setQrSize({ width: parseInt(width), height: parseInt(height) })
          console.log("QR position restored:", { x: parseInt(left), y: parseInt(top), width: parseInt(width), height: parseInt(height) })
        }
      }
      const qrEl = badgeEl.querySelector(".qr")
      if (qrEl?.src) {
        console.log("QR URL restored:", qrEl.src)
        setQrUrl(qrEl.src)
        setQrText("")
        setQrVisible(true)
      }
      badgeEl.querySelectorAll(".text-field").forEach((el) => {
        const text = (el.textContent || "").trim()
        const style = el.getAttribute("style") || ""
        const styles = {}
        style.split(";").forEach((s) => {
          const [k, v] = s.split(":").map((x) => x.trim())
          if (k && v) styles[k] = v
        })
        const updates = {
          visible: true,
          x: Number.parseInt(styles.left) || 50,
          y: Number.parseInt(styles.top) || 100,
          width: Number.parseInt(styles.width) || 200,
          height: Number.parseInt(styles.height) || 40,
          fontSize: Number.parseInt(styles["font-size"]) || 24,
          fontFamily: (styles["font-family"] || "Arial").replace(/['"]/g, "").split(",")[0].trim(),
          fontWeight: styles["font-weight"] === "bold" ? "700" : styles["font-weight"] || "400",
          color: styles.color || "#000000",
          textAlign: styles["text-align"] || "center",
        }
        if (text.startsWith("{{") && text.endsWith("}}")) {
          const fieldKey = text.slice(2, -2).trim()
          const field = inputFields.find((f) => f.fieldKey === fieldKey)
          if (!field) return
          updateField(field.id, updates)
        } else {
          const customCount = inputFields.filter((f) => !f.fieldKey).length + 1
          const newId = `custom_${Date.now()}`
          const newField = {
            id: newId,
            label: `Custom Text ${customCount}`,
            text: text,
            ...updates,
          }
          setInputFields((prev) => [...prev, newField])
        }
      })
    } catch (err) {
      console.error("parseTemplate crashed:", err)
    }
  }
// Load edit data from location state
useEffect(() => {
  const stateData = location?.state?.state
  if (stateData?.isEdit && stateData?.badge) {
    const badge = stateData.badge
    console.log("[v0] Loading badge for edit:", badge)

    setIsEdit(true)
    setBadgeId(badge.id)
    setBadgeTitle(badge.title || "New Badge Template")
    setSelectedTickets(badge.event_ticket || [0])

    // Set badge size
    if (badge.badge_size && canvasSizes[badge.badge_size]) {
      setCanvasSize(badge.badge_size)
    }

    // Set default background flag
    if (badge.default_bg === 1 || badge.default_bg === true) {
      setUseDefaultBackground(true)
      setBgPreview(DEFAULT_BACKGROUND_URL)
      setBackgroundUploadStatus("success")
      setStep1Completed(true)
    }

    // Parse the template to restore fields, background, QR, etc.
    if (badge.template) {
      parseTemplate(badge.template)
    }
  }
}, []) // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ticketDropdownRef.current && !ticketDropdownRef.current.contains(event.target)) {
        setIsTicketDropdownOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const handleTicketToggle = (ticketId) => {
    if (ticketId === 0) {
      setSelectedTickets([0])
    } else {
      const newSelection = selectedTickets.includes(0)
        ? [ticketId]
        : selectedTickets.includes(ticketId)
          ? selectedTickets.filter(id => id !== ticketId)
          : [...selectedTickets, ticketId]
      setSelectedTickets(newSelection.length === 0 ? [0] : newSelection)
    }
  }

  const getTicketDisplayText = () => {
    if (selectedTickets.includes(0) || selectedTickets.length === 0) {
      return 'All Tickets'
    }
    if (selectedTickets.length === 1) {
      const ticket = tickets.find(t => t.id === selectedTickets[0])
      return ticket?.ticket_name || 'All Tickets'
    }
    return `${selectedTickets.length} Tickets Selected`
  }

  const handleRemoveBackground = () => {
    showConfirm("Are you sure you want to remove the background image?", () => {
      setBgFile(null)
      setBgPreview(null)
      setBackgroundUploadStatus("idle")
      setUseDefaultBackground(false)
      if (bgImageInputRef.current) {
        bgImageInputRef.current.value = ""
      }
    })
  }

  const handleDefaultBackgroundToggle = () => {
    if (isLocked || (!isEdit && step1Completed)) return
    const newValue = !useDefaultBackground
    setUseDefaultBackground(newValue)
    if (newValue) {
      setBgPreview(DEFAULT_BACKGROUND_URL)
      setBgFile(null)
      setBackgroundUploadStatus("success")
      if (bgImageInputRef.current) {
        bgImageInputRef.current.value = ""
      }
    } else {
      setBgPreview(null)
      setBackgroundUploadStatus("idle")
    }
  }

useEffect(() => {
  if (qrText.trim() && qrVisible) {
    import("qrcode").then(async (QRCode) => {
      try {
        // Generate QR as Data URL first
        const qrDataUrl = await QRCode.default.toDataURL(qrText, { 
          width: 300, 
          margin: 1,
          errorCorrectionLevel: 'H'
        })
        
        // Convert Data URL to Blob
        const response = await fetch(qrDataUrl)
        const blob = await response.blob()
        
        // Upload blob to AWS
        try {
          const qrFile = new File([blob], `qr-${Date.now()}.png`, { type: 'image/png' })
          const uploadResponse = await uploadFilesAWS([qrFile])
          
          const uploadedUrls = uploadResponse?.data?.uploadedUrls || uploadResponse?.uploadedUrls || {}
          const qrAwsUrl = Object.values(uploadedUrls).flat()[0]
          
          if (qrAwsUrl) {
            setQrImage(qrAwsUrl) // Store AWS URL
          } else {
            console.error("Failed to get QR AWS URL")
          }
        } catch (err) {
          console.error("QR upload failed:", err)
        }
      } catch (err) {
        console.error("QR generation failed:", err)
      }
    })
  } else {
    setQrImage(null)
  }
}, [qrText, qrVisible])

  const handleTextMouseDown = (e, id) => {
    if (isLocked) return
    e.stopPropagation()
    setSelectedFieldId(id)
    setExpandedFieldId(id)
    const rect = e.currentTarget.getBoundingClientRect()
    setDragOffset({ x: e.clientX - rect.left, y: e.clientY - rect.top })
    setDraggingTextId(id)
  }

  const handleTextResizeDown = (e, id) => {
    if (isLocked) return
    e.stopPropagation()
    setResizingTextId(id)
    setDragOffset({ x: e.clientX, y: e.clientY })
  }

  const handleImageMouseDown = (e, id) => {
    if (isLocked) return
    e.stopPropagation()
    const rect = e.currentTarget.getBoundingClientRect()
    setDragOffset({ x: e.clientX - rect.left, y: e.clientY - rect.top })
    setDraggingImageId(id)
  }

  const handleImageResizeDown = (e, id) => {
    if (isLocked) return
    e.stopPropagation()
    setResizingImageId(id)
    setDragOffset({ x: e.clientX, y: e.clientY })
  }

  const handleQRMouseDown = (e) => {
    if (isLocked) return
    const rect = e.currentTarget.getBoundingClientRect()
    setDragOffset({ x: e.clientX - rect.left, y: e.clientY - rect.top })
    setIsDragging(true)
  }

  const handleQRResizeDown = (e) => {
    if (isLocked) return
    e.stopPropagation()
    setResizingQR(true)
    setDragOffset({ x: e.clientX, y: e.clientY })
  }

  const handleMouseMove = (e) => {
    if (!badgeRef.current || isLocked) return
    const badgeRect = badgeRef.current.getBoundingClientRect()
    const scale = badgeRect.width / BADGE_WIDTH
    if (draggingTextId) {
      let nx = (e.clientX - badgeRect.left) / scale - dragOffset.x / scale
      let ny = (e.clientY - badgeRect.top) / scale - dragOffset.y / scale
      nx = Math.max(0, Math.min(nx, BADGE_WIDTH - 100))
      ny = Math.max(0, Math.min(ny, BADGE_HEIGHT - 50))
      updateField(draggingTextId, { x: nx, y: ny })
    }
    if (resizingTextId) {
      const field = inputFields.find((f) => f.id === resizingTextId)
      if (!field) return
      const deltaX = (e.clientX - dragOffset.x) / scale
      const deltaY = (e.clientY - dragOffset.y) / scale
      const newW = Math.max(50, field.width + deltaX)
      const newH = Math.max(20, field.height + deltaY)
      updateField(resizingTextId, { width: newW, height: newH })
      setDragOffset({ x: e.clientX, y: e.clientY })
    }
    if (draggingImageId) {
      const img = imageFiles.find((i) => i.id === draggingImageId)
      if (!img) return
      let nx = (e.clientX - badgeRect.left) / scale - dragOffset.x / scale
      let ny = (e.clientY - badgeRect.top) / scale - dragOffset.y / scale
      nx = Math.max(0, Math.min(nx, BADGE_WIDTH - img.width))
      ny = Math.max(0, Math.min(ny, BADGE_HEIGHT - img.height))
      setImageFiles((prev) => prev.map((i) => (i.id === draggingImageId ? { ...i, x: nx, y: ny } : i)))
    }
    if (resizingImageId) {
      const img = imageFiles.find((i) => i.id === resizingImageId)
      if (!img) return
      const deltaX = (e.clientX - dragOffset.x) / scale
      const deltaY = (e.clientY - dragOffset.y) / scale
      const newW = Math.max(30, img.width + deltaX)
      const newH = Math.max(30, img.height + deltaY)
      setImageFiles((prev) => prev.map((i) => (i.id === resizingImageId ? { ...i, width: newW, height: newH } : i)))
      setDragOffset({ x: e.clientX, y: e.clientY })
    }
    if (isDragging) {
      let nx = (e.clientX - badgeRect.left) / scale - dragOffset.x / scale
      let ny = (e.clientY - badgeRect.top) / scale - dragOffset.y / scale
      nx = Math.max(0, Math.min(nx, BADGE_WIDTH - qrSize.width))
      ny = Math.max(0, Math.min(ny, BADGE_HEIGHT - qrSize.height))
      setQrPosition({ x: nx, y: ny })
    }
    if (resizingQR) {
      const deltaX = (e.clientX - dragOffset.x) / scale
      const deltaY = (e.clientY - dragOffset.y) / scale
      const newW = Math.max(40, Math.min(300, qrSize.width + deltaX))
      const newH = Math.max(40, Math.min(300, qrSize.height + deltaY))
      setQrSize({ width: newW, height: newH })
      setDragOffset({ x: e.clientX, y: e.clientY })
    }
  }

  const handleMouseUp = () => {
    setIsDragging(false)
    setDraggingTextId(null)
    setDraggingImageId(null)
    setResizingImageId(null)
    setResizingQR(false)
    setResizingTextId(null)
  }

  const handleSaveStep1 = async () => {
    if (!useDefaultBackground && !bgFile && !bgPreview) {
      showAlert("Upload background first", "warning")
      return
    }
    if (useDefaultBackground && !imageFiles.length) {
      setStep1Completed(true)
      setActiveTab("fields")
      showAlert("Default background applied! Now add fields & QR.", "success")
      return
    }
    if (!imageFiles.length) {
      setStep1Completed(true)
      setActiveTab("fields")
      showAlert("Background saved! Now add fields & QR.", "success")
      return
    }
    const performMerge = async () => {
      setIsGenerating(true)
      try {
        const hide = () => {
          document.querySelectorAll(".resize-handle, .delete-btn").forEach((el) => {
            el.style.display = "none"
          })
        }
        const show = () => {
          document.querySelectorAll(".resize-handle, .delete-btn").forEach((el) => {
            el.style.display = ""
          })
        }
        hide()
        await new Promise((r) => setTimeout(r, 100))
        const html2canvas = (await import("html2canvas")).default
        const canvas = await html2canvas(badgeRef.current, {
          scale: 2,
          useCORS: true,
          allowTaint: true,
          backgroundColor: null,
        })
        show()
        const blob = await new Promise((r) => canvas.toBlob(r, "image/png"))
        const mergedFile = new File([blob], `merged-bg-${Date.now()}.png`, {
          type: "image/png",
        })
        const response = await uploadFilesAWS([mergedFile])
        const uploadedUrls = response?.data?.uploadedUrls || response?.uploadedUrls || {}
        const mergedBgUrl = Object.values(uploadedUrls).flat().pop()
        if (!mergedBgUrl) throw new Error("Failed to get merged background URL")
        setBgPreview(mergedBgUrl)
        setImageFiles([])
        setStep1Completed(true)
        setBgFile(null)
        setUseDefaultBackground(false)
        setActiveTab("fields")
        showAlert("Background saved! Now add fields & QR.", "success")
      } catch (err) {
        console.error(err)
        showAlert("Failed: " + (err.message || "Unknown error"), "danger")
      } finally {
        setIsGenerating(false)
      }
    }
    showConfirm("Merge background & images to upload as one image?", performMerge)
  }



  const handleFinalSave = () => {
showConfirm(`Save badge "${badgeTitle}"?`, async () => {
    setIsGenerating(true)
    try {
      const visibleFields = inputFields.filter((f) => f.visible)
      const finalQrUrl = qrVisible && qrImage ? qrImage : null

      const finalBgUrl = useDefaultBackground 
        ? DEFAULT_BACKGROUND_URL 
        : bgAwsUrl || bgPreview

      const { w, h } = BADGE_SIZE_INCHES

      const htmlCode = `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>${badgeTitle}</title>
  <style>
    * { margin:0; padding:0; box-sizing:border-box; }
    body { background:#FFFFFF; display:flex; justify-content:center; align-items:center; min-height:100vh; }
    .badge {
      position:relative;
     
      width:${w}in;
      height:${h}in;
    
      background:url('${finalBgUrl}') center/cover no-repeat;
      overflow:hidden;
   
    }
    .qr {
      position:absolute;
      left:${qrPosition.x}px;
      top:${qrPosition.y}px;
      width:${qrSize.width}px;
      height:${qrSize.height}px;
      pointer-events:none;
    }
    .text-field {
      position:absolute;
      padding:10px 14px;
      background:transparent;
      border:none;
      outline:none;
      pointer-events:none;
      white-space:nowrap;
      overflow:hidden;
      text-overflow:ellipsis;
      line-height:1.2;
    }
  </style>
</head>
<body>
  <div class="badge">
    ${finalQrUrl ? `<img src="${finalQrUrl}" class="qr" alt="QR Code" crossorigin="anonymous">` : ""}
    ${visibleFields
      .map(
        (field) => `<div class="text-field"
                    style="
                      left:${field.x}px;
                      top:${field.y}px;
                      width:${field.width}px;
                      height:${field.height}px;
                      font-size:${field.fontSize}px;
                      font-family:'${field.fontFamily}',sans-serif;
                      font-weight:${field.fontWeight};
                      color:${field.color};
                      text-align:${field.textAlign};
                    ">
                    ${field.fieldKey ? `{{${field.fieldKey}}}` : field.text}
                  </div>`,
      )
      .join("")}
  </div>
</body>
</html>`.trim()
        if (isEdit && badgeId) {
      
          await UpdateBadge({
            id: badgeId,
            title: badgeTitle,
            template: htmlCode,
            event_ticket: selectedTickets,
            default_bg: useDefaultBackground,
            badge_size: canvasSize,
            
          })
          showToast(`Success! Template updated: "${badgeTitle}"`, "success")
          setTimeout(() => {
            history.push("/events/admin/badge")
          }, 1000)
        } else {
          // UPDATED: Add badge_size and background_image_url to createBadge
          await createBadge({
            title: badgeTitle,
            template: htmlCode,
            event_ticket: selectedTickets,
            default_bg: useDefaultBackground,
            badge_size: canvasSize,
            
          })
          showToast(`Success! Template saved: "${badgeTitle}"`, "success")
          setTimeout(() => {
            history.push("/events/admin/badge")
          }, 1000)
        }
        setGeneratedHtml(htmlCode)
        setIsLocked(true)
      } catch (err) {
        console.error(err)
        showToast("Failed to save: " + (err.message || "Unknown error"), "error")
      } finally {
        setIsGenerating(false)
      }
    })
  }

  const copyHtmlToClipboard = () => {
    navigator.clipboard.writeText(generatedHtml)
    showAlert("HTML code copied!", "success")
  }

  const handleChangeBackground = () => {
    showConfirm("This will reset and allow you to upload new background/images. Continue?", () => {
      setBgPreview(null)
      setStep1Completed(false)
      setImageFiles([])
      setBackgroundUploadStatus("idle")
      setBgFile(null)
      setUseDefaultBackground(false)
      setActiveTab("background")
    })
  }

  const handleResetAll = () => {
    showConfirm("Reset everything?", () => {
      window.location.reload()
    })
  }
  const sidebarStyles = {
    container: {
      width: "400px",
      backgroundColor: "#ffffff",
      borderRadius: "20px",
      boxShadow: "0 10px 40px rgba(0,0,0,0.08)",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      height: "calc(100vh - 140px)",
    },
    header: {
      background: "linear-gradient(135deg, #1e3a5f 0%, #2d5a87 100%)",
      padding: "26px 28px",
      color: "#ffffff",
      flexShrink: 0,
    },
    headerTitle: {
      fontSize: "22px",
      fontWeight: "700",
      marginBottom: "6px",
      letterSpacing: "-0.3px",
    },
    headerSubtitle: {
      fontSize: "13px",
      opacity: 0.85,
      fontWeight: "400",
    },
    tabContainer: {
      display: "flex",
      gap: "8px",
      padding: "16px 28px",
      backgroundColor: "#f8fafc",
      borderBottom: "1px solid #e2e8f0",
      flexShrink: 0,
    },
    tab: {
      flex: 1,
      padding: "12px 20px",
      border: "none",
      backgroundColor: "transparent",
      borderRadius: "8px",
      fontSize: "14px",
      fontWeight: "600",
      cursor: "pointer",
      transition: "all 0.2s ease",
      color: "#64748b",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "8px",
    },
    tabActive: {
      backgroundColor: "#ffffff",
      color: "#1e3a5f",
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    },
    scrollableContent: {
      flex: 1,
      overflowY: "auto",
      overflowX: "hidden",
      minHeight: 0,
    },
    section: {
      padding: "24px 28px",
      borderBottom: "1px solid #f1f5f9",
    },
    sectionTitle: {
      fontSize: "11px",
      fontWeight: "700",
      color: "#64748b",
      marginBottom: "16px",
      textTransform: "uppercase",
      letterSpacing: "0.8px",
    },
    fieldList: {
      padding: "16px 28px 28px",
    },
    fieldItem: {
      marginBottom: "12px",
      border: "1px solid #e2e8f0",
      borderRadius: "14px",
      backgroundColor: "#ffffff",
      overflow: "hidden",
      transition: "all 0.25s ease",
      boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
    },
    fieldItemActive: {
      borderColor: "#1e3a5f",
      boxShadow: "0 0 0 3px rgba(30, 58, 95, 0.1), 0 4px 12px rgba(0,0,0,0.08)",
    },
    fieldHeader: {
      display: "flex",
      alignItems: "center",
      padding: "16px 18px",
      cursor: "pointer",
      transition: "background-color 0.15s ease",
    },
    fieldIcon: {
      width: "42px",
      height: "42px",
      marginRight: "14px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#f1f5f9",
      borderRadius: "12px",
      color: "#64748b",
      fontSize: "14px",
      fontWeight: "600",
      transition: "all 0.2s ease",
    },
    fieldIconActive: {
      backgroundColor: "#1e3a5f",
      color: "#ffffff",
    },
    fieldLabel: {
      flex: 1,
      fontSize: "14px",
      color: "#334155",
      fontWeight: "500",
    },
    toggleSwitch: {
      width: "52px",
      height: "28px",
      backgroundColor: "#e2e8f0",
      borderRadius: "14px",
      cursor: "pointer",
      position: "relative",
      transition: "all 0.3s ease",
      marginLeft: "auto",
      flexShrink: 0,
    },
    toggleSwitchActive: {
      backgroundColor: "#1e3a5f",
    },
    toggleKnob: {
      width: "22px",
      height: "22px",
      backgroundColor: "#ffffff",
      borderRadius: "50%",
      position: "absolute",
      top: "3px",
      left: "3px",
      transition: "all 0.3s ease",
      boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
    },
    toggleKnobActive: {
      left: "27px",
    },
    designPanel: {
      padding: "18px 20px",
      backgroundColor: "#f8fafc",
      borderTop: "1px solid #e2e8f0",
    },
    designRow: {
      display: "flex",
      gap: "14px",
      marginBottom: "16px",
    },
    designGroup: {
      flex: 1,
    },
    label: {
      fontSize: "11px",
      fontWeight: "600",
      color: "#64748b",
      marginBottom: "8px",
      display: "block",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
    },
    input: {
      width: "100%",
      padding: "12px 14px",
      border: "1px solid #e2e8f0",
      borderRadius: "10px",
      fontSize: "14px",
      color: "#334155",
      outline: "none",
      backgroundColor: "#ffffff",
      transition: "all 0.2s ease",
    },
    select: {
      width: "100%",
      padding: "12px 14px",
      border: "1px solid #e2e8f0",
      borderRadius: "10px",
      fontSize: "14px",
      color: "#334155",
      backgroundColor: "#ffffff",
      outline: "none",
      cursor: "pointer",
      transition: "all 0.2s ease",
    },
    colorRow: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
    },
    colorInput: {
      width: "46px",
      height: "46px",
      border: "2px solid #e2e8f0",
      borderRadius: "10px",
      cursor: "pointer",
      padding: "3px",
    },
    alignGroup: {
      display: "flex",
      gap: "8px",
    },
    alignButton: {
      flex: 1,
      padding: "12px",
      border: "1px solid #e2e8f0",
      backgroundColor: "#ffffff",
      borderRadius: "10px",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "all 0.2s ease",
      color: "#64748b",
    },
    alignButtonActive: {
      backgroundColor: "#1e3a5f",
      borderColor: "#1e3a5f",
      color: "#ffffff",
    },
    uploadButton: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "12px",
      padding: "16px 18px",
      border: "2px dashed #cbd5e1",
      borderRadius: "14px",
      backgroundColor: "#f8fafc",
      cursor: "pointer",
      fontSize: "14px",
      color: "#64748b",
      width: "100%",
      transition: "all 0.25s ease",
      fontWeight: "500",
    },
    statusText: {
      fontSize: "12px",
      color: "#94a3b8",
      marginTop: "12px",
      textAlign: "center",
    },
    primaryButton: {
      width: "100%",
      padding: "16px 18px",
      backgroundColor: "#1e3a5f",
      color: "#ffffff",
      border: "none",
      borderRadius: "14px",
      fontSize: "15px",
      fontWeight: "600",
      cursor: "pointer",
      marginTop: "14px",
      transition: "all 0.25s ease",
      boxShadow: "0 4px 14px rgba(30, 58, 95, 0.25)",
    },
    successButton: {
      backgroundColor: "#059669",
      boxShadow: "0 4px 14px rgba(5, 150, 105, 0.25)",
    },
    confirmBox: {
      marginTop: "20px",
      padding: "20px",
      backgroundColor: "#ecfdf5",
      borderRadius: "14px",
      border: "2px solid #10b981",
    },
    confirmText: {
      fontSize: "14px",
      color: "#047857",
      marginBottom: "14px",
      fontWeight: "500",
      textAlign: "center",
      lineHeight: "1.5",
    },
    confirmButton: {
      width: "100%",
      padding: "16px 18px",
      backgroundColor: "#059669",
      color: "#ffffff",
      border: "none",
      borderRadius: "12px",
      fontSize: "15px",
      fontWeight: "600",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "10px",
      boxShadow: "0 4px 12px rgba(5, 150, 105, 0.3)",
      transition: "all 0.25s ease",
    },
    saveButtonContainer: {
      padding: "20px 28px",
      borderTop: "1px solid #e2e8f0",
      backgroundColor: "#f8fafc",
      flexShrink: 0,
    },
    saveButton: {
      width: "100%",
      padding: "18px 24px",
      backgroundColor: "#1e3a5f",
      color: "#ffffff",
      border: "none",
      borderRadius: "14px",
      fontSize: "16px",
      fontWeight: "700",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "12px",
      boxShadow: "0 6px 20px rgba(30, 58, 95, 0.3)",
      transition: "all 0.3s ease",
    },
    saveButtonHover: {
      transform: "translateY(-2px)",
      boxShadow: "0 8px 25px rgba(30, 58, 95, 0.4)",
    },
    updateButton: {
      background: "linear-gradient(135deg, rgb(24, 71, 120) 0%, rgb(49, 113, 156) 100%)",
      boxShadow: "0 6px 20px rgba(14, 165, 233, 0.3)",
    },
    defaultBgToggleContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "16px 18px",
      marginBottom: "16px",
      border: "1px solid #e2e8f0",
      borderRadius: "14px",
      backgroundColor: "#ffffff",
      transition: "all 0.25s ease",
    },
    defaultBgToggleContainerActive: {
      borderColor: "#10b981",
      backgroundColor: "#ecfdf5",
    },
    defaultBgLabel: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
    },
    defaultBgIcon: {
      width: "42px",
      height: "42px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#f1f5f9",
      borderRadius: "12px",
      color: "#64748b",
      fontSize: "18px",
      transition: "all 0.2s ease",
    },
    defaultBgIconActive: {
      backgroundColor: "#10b981",
      color: "#ffffff",
    },
    defaultBgText: {
      fontSize: "14px",
      color: "#334155",
      fontWeight: "500",
    },
    defaultBgSubtext: {
      fontSize: "12px",
      color: "#94a3b8",
      marginTop: "2px",
    },
    divider: {
      margin: "20px 0",
      position: "relative",
      textAlign: "center",
    },
    dividerText: {
      fontSize: "13px",
      color: "#94a3b8",
      fontWeight: "500",
      position: "relative",
      zIndex: 1,
      backgroundColor: "#ffffff",
      padding: "0 12px",
    },
  }
  const renderFieldDesignPanel = (field) => (
    <div style={sidebarStyles.designPanel}>
      {!field.fieldKey && (
        <div style={{ ...sidebarStyles.designRow, marginBottom: "16px" }}>
          <div style={{ flex: 1 }}>
            <label style={sidebarStyles.label}>Text Content</label>
            <input
              type="text"
              style={sidebarStyles.input}
              value={field.text}
              onChange={(e) => updateField(field.id, { text: e.target.value })}
              disabled={isLocked}
              placeholder="Enter custom text"
            />
          </div>
        </div>
      )}
      <div style={sidebarStyles.designRow}>
        <div style={sidebarStyles.designGroup}>
          <label style={sidebarStyles.label}>Size</label>
          <select
            style={sidebarStyles.select}
            value={field.fontSize}
            onChange={(e) => updateField(field.id, { fontSize: Number.parseInt(e.target.value) })}
            disabled={isLocked}
          >
            {[12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 36, 40, 44, 48, 52, 56, 60, 64, 72, 80, 96].map((size) => (
              <option key={size} value={size}>
                {size}px
              </option>
            ))}
          </select>
        </div>
        <div style={{ ...sidebarStyles.designGroup, flex: 2 }}>
          <label style={sidebarStyles.label}>Font</label>
          <select
            style={{ ...sidebarStyles.select, fontFamily: field.fontFamily }}
            value={field.fontFamily}
            onChange={(e) => updateField(field.id, { fontFamily: e.target.value })}
            disabled={isLocked}
          >
            {fontFamilies.map((font) => (
              <option key={font} value={font} style={{ fontFamily: font }}>
                {font}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div style={sidebarStyles.designRow}>
        <div style={sidebarStyles.designGroup}>
          <label style={sidebarStyles.label}>Weight</label>
          <select
            style={sidebarStyles.select}
            value={field.fontWeight}
            onChange={(e) => updateField(field.id, { fontWeight: e.target.value })}
            disabled={isLocked}
          >
            {fontWeights.map((w) => (
              <option key={w.value} value={w.value}>
                {w.label}
              </option>
            ))}
          </select>
        </div>
        <div style={sidebarStyles.designGroup}>
          <label style={sidebarStyles.label}>Color</label>
          <div style={sidebarStyles.colorRow}>
            <input
              type="color"
              style={sidebarStyles.colorInput}
              value={field.color}
              onChange={(e) => updateField(field.id, { color: e.target.value })}
              disabled={isLocked}
            />
            <span style={{ fontSize: "12px", color: "#64748b", fontWeight: "600" }}>{field.color.toUpperCase()}</span>
          </div>
        </div>
      </div>
      <div>
        <label style={sidebarStyles.label}>Alignment</label>
        <div style={sidebarStyles.alignGroup}>
          {["left", "center", "right"].map((align) => (
            <button
              key={align}
              style={{
                ...sidebarStyles.alignButton,
                ...(field.textAlign === align ? sidebarStyles.alignButtonActive : {}),
              }}
              onClick={() => updateField(field.id, { textAlign: align })}
              disabled={isLocked}
            >
              {align === "left" && <MdFormatAlignLeft size={20} />}
              {align === "center" && <MdFormatAlignCenter size={20} />}
              {align === "right" && <MdFormatAlignRight size={20} />}
            </button>
          ))}
        </div>
      </div>
    </div>
  )
  const mainContainerStyle = {
    minHeight: "100vh",
    backgroundColor: "#f1f5f9",
    padding: "32px",
  }
  const headerStyle = {
    marginBottom: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  }
  const headerTitleStyle = {
    fontSize: "32px",
    fontWeight: "700",
    color: "#1e293b",
    margin: 0,
    letterSpacing: "-0.5px",
  }
  const headerSubtitleStyle = {
    fontSize: "15px",
    color: "#64748b",
    margin: "6px 0 0 0",
    fontWeight: "400",
  }
  const canvasContainerStyle = {
    flex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#e2e8f0",
    borderRadius: "20px",
    padding: "50px",
    minHeight: "700px",
 
    border: "1px solid #cbd5e1",
  }
  const badgeCanvasStyle = {
    width: BADGE_WIDTH,
    height: BADGE_HEIGHT,
    background: bgPreview ? `url(${bgPreview}) center/cover no-repeat` : "#ffffff",
    position: "relative",
    borderRadius: "16px",
    boxShadow: "0 25px 80px rgba(0,0,0,0.18)",
    overflow: "hidden",
  }
  const emptyCanvasStyle = {
    position: "absolute",
    inset: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    color: "#94a3b8",
    backgroundColor: "#f8fafc",
    borderRadius: "16px",
  }
  const renderBackgroundTab = () => (
    <div style={sidebarStyles.section}>
      <div style={sidebarStyles.sectionTitle}>Background Image</div>
      {(!step1Completed || isEdit) && (
        <div
          style={{
            ...sidebarStyles.defaultBgToggleContainer,
            ...(useDefaultBackground ? sidebarStyles.defaultBgToggleContainerActive : {}),
          }}
        >
          <div style={sidebarStyles.defaultBgLabel}>
            <span
              style={{
                ...sidebarStyles.defaultBgIcon,
                ...(useDefaultBackground ? sidebarStyles.defaultBgIconActive : {}),
              }}
            >
              <FiGrid size={18} />
            </span>
            <div>
              <div style={sidebarStyles.defaultBgText}>Use Default Background</div>
              <div style={sidebarStyles.defaultBgSubtext}>Quick start with preset design</div>
            </div>
          </div>
          <div
            style={{
              ...sidebarStyles.toggleSwitch,
              ...(useDefaultBackground ? sidebarStyles.toggleSwitchActive : {}),
              backgroundColor: useDefaultBackground ? "#10b981" : "#e2e8f0",
            }}
            onClick={() => {
              if (isLocked) return
              handleDefaultBackgroundToggle()
            }}
          >
            <div
              style={{
                ...sidebarStyles.toggleKnob,
                ...(useDefaultBackground ? sidebarStyles.toggleKnobActive : {}),
              }}
            />
          </div>
        </div>
      )}
      {((!step1Completed && !useDefaultBackground) || (isEdit && !useDefaultBackground)) && (
        <>
          <div style={sidebarStyles.divider}>
            <span style={sidebarStyles.dividerText}>OR</span>
          </div>
          <input
            ref={bgImageInputRef}
            type="file"
            accept="image/*"
            onChange={handleBgImageChange}
            style={{ display: "none" }}
          />
          <button
            style={sidebarStyles.uploadButton}
            onClick={() => bgImageInputRef.current.click()}
            disabled={isLocked || (!isEdit && step1Completed)}
          >
            <MdUpload size={22} />
            {bgPreview && !useDefaultBackground ? "Change Background" : "Upload Custom Background"}
          </button>
          <p style={sidebarStyles.statusText}>
            {bgPreview && !useDefaultBackground ? "Background image loaded" : "PNG, JPG up to 5MB"}
          </p>
        </>
      )}
      {bgPreview && (!step1Completed || isEdit) && !useDefaultBackground && (
        <button
          style={{
            ...sidebarStyles.uploadButton,
            color: "#dc2626",
            borderColor: "#fecaca",
            backgroundColor: "#fef2f2",
            marginTop: "12px",
          }}
          onClick={handleRemoveBackground}
          disabled={isLocked}
        >
          <IoClose size={22} />
          Remove Background
        </button>
      )}
      {step1Completed && !isEdit && (
        <button
          style={{
            ...sidebarStyles.uploadButton,
            color: "#d97706",
            borderColor: "#fde68a",
            backgroundColor: "#fffbeb",
            marginTop: "12px",
          }}
          onClick={handleChangeBackground}
          disabled={isLocked}
        >
          <IoClose size={20} />
          Reset Background
        </button>
      )}
{(() => {
  const showAddLogos =
    (backgroundUploadStatus === "success" || useDefaultBackground || (isEdit && bgPreview))
  console.log("[v0] Add Logos/Images visibility check:", {
    isEdit,
    bgPreview: bgPreview?.slice(0, 50),
    backgroundUploadStatus,
    useDefaultBackground,
    step1Completed,
    showAddLogos,
  })
  return showAddLogos
})() && (
  <>
    <input
      ref={imageInputRef}
      type="file"
      accept="image/*"
      multiple
      onChange={(e) => {
              Array.from(e.target.files).forEach((file) => {
                const reader = new FileReader()
                reader.onload = (ev) => {
                  const img = new Image()
                  img.onload = () => {
                    const max = 200
                    let w = img.width,
                      h = img.height
                    if (w > max || h > max) {
                      const ratio = Math.min(max / w, max / h)
                      w *= ratio
                      h *= ratio
                    }
                    setImageFiles((prev) => [
                      ...prev,
                      {
                        id: Date.now() + Math.random(),
                        file,
                        preview: ev.target.result,
                        x: 50,
                        y: 50,
                        width: w,
                        height: h,
                      },
                    ])
                  }
                  img.src = ev.target.result
                }
                reader.readAsDataURL(file)
              })
            }}
            style={{ display: "none" }}
          />
          <button
            style={{ ...sidebarStyles.uploadButton, marginTop: "16px" }}
            onClick={() => imageInputRef.current.click()}
            disabled={isLocked}
          >
            <MdUpload size={20} />
            Add Logos/Images
          </button>
          {imageFiles.length > 0 && (
            <button
              style={{
                ...sidebarStyles.uploadButton,
                color: "#dc2626",
                borderColor: "#fecaca",
                backgroundColor: "#fef2f2",
                marginTop: "12px",
              }}
              onClick={handleClearAllImages}
              disabled={isLocked}
            >
              <IoClose size={20} />
              Clear All ({imageFiles.length})
            </button>
          )}
        </>
      )}
      {((!step1Completed && (backgroundUploadStatus === "success" || useDefaultBackground)) ||
        (isEdit && bgPreview)) && (
        <div style={sidebarStyles.confirmBox}>
          <p style={sidebarStyles.confirmText}>
            {useDefaultBackground
              ? "Default background selected! Click below to proceed."
              : "Background ready! Click below to proceed to add fields."}
          </p>
          <button style={sidebarStyles.confirmButton} onClick={handleSaveStep1} disabled={isGenerating || isLocked}>
            <MdCheckCircle size={20} />
            {isGenerating ? "Processing..." : "Confirm & Add Fields"}
          </button>
        </div>
      )}
    </div>
  )
  const renderFieldsTab = () => (
    <>
      <div style={{ padding: "20px 28px" }}>
        {/* <label style={sidebarStyles.label}>QR Code URL</label>
        <input
          type="text"
          style={sidebarStyles.input}
          value={qrText}
          onChange={(e) => setQrText(e.target.value)}
          disabled={isLocked}
          placeholder="Enter QR code URL"
        /> */}
      </div>
      <div style={{ ...sidebarStyles.section, borderBottom: "none", paddingBottom: "10px", paddingTop: "0" }}>
        <div style={sidebarStyles.sectionTitle}>Fields</div>
        <p style={{ fontSize: "13px", color: "#94a3b8", margin: 0 }}>Toggle fields on and customize their style</p>
      </div>
      <div style={sidebarStyles.fieldList}>
        {inputFields.filter((field) => field.fieldKey).map((field) => (
          <div
            key={field.id}
            style={{
              ...sidebarStyles.fieldItem,
              ...(field.visible ? sidebarStyles.fieldItemActive : {}),
            }}
          >
            <div
              style={sidebarStyles.fieldHeader}
              onClick={() => {
                if (!isLocked) {
                  if (field.visible) {
                    setExpandedFieldId(expandedFieldId === field.id ? null : field.id)
                    setSelectedFieldId(field.id)
                  } else {
                    toggleFieldVisibility(field.id)
                  }
                }
              }}
            >
              <span
                style={{
                  ...sidebarStyles.fieldIcon,
                  ...(field.visible ? sidebarStyles.fieldIconActive : {}),
                }}
              >
                <FiType size={18} />
              </span>
              <span style={sidebarStyles.fieldLabel}>{field.label}</span>
              <div
                style={{
                  ...sidebarStyles.toggleSwitch,
                  ...(field.visible ? sidebarStyles.toggleSwitchActive : {}),
                }}
                onClick={(e) => {
                  e.stopPropagation()
                  if (!isLocked) {
                    toggleFieldVisibility(field.id)
                  }
                }}
              >
                <div
                  style={{
                    ...sidebarStyles.toggleKnob,
                    ...(field.visible ? sidebarStyles.toggleKnobActive : {}),
                  }}
                />
              </div>
              {field.visible && (
                <span style={{ marginLeft: "12px", color: "#64748b" }}>
                  {expandedFieldId === field.id ? <MdExpandLess size={24} /> : <MdExpandMore size={24} />}
                </span>
              )}
            </div>
            {field.visible && expandedFieldId === field.id && renderFieldDesignPanel(field)}
          </div>
        ))}
        <div
          style={{
            ...sidebarStyles.fieldItem,
            ...(qrVisible ? sidebarStyles.fieldItemActive : {}),
          }}
        >
          <div
            style={sidebarStyles.fieldHeader}
            onClick={() => {
              if (!isLocked) {
                setQrVisible(!qrVisible)
              }
            }}
          >
            <span
              style={{
                ...sidebarStyles.fieldIcon,
                ...(qrVisible ? sidebarStyles.fieldIconActive : {}),
              }}
            >
              <FiGrid size={18} />
            </span>
            <span style={sidebarStyles.fieldLabel}>QR Code</span>
            <div
              style={{
                ...sidebarStyles.toggleSwitch,
                ...(qrVisible ? sidebarStyles.toggleSwitchActive : {}),
              }}
            >
              <div
                style={{
                  ...sidebarStyles.toggleKnob,
                  ...(qrVisible ? sidebarStyles.toggleKnobActive : {}),
                }}
              />
            </div>
          </div>
        </div>
        <div style={{ ...sidebarStyles.sectionTitle, marginTop: "20px" }}>Custom Fields</div>
        <button
          style={{ ...sidebarStyles.uploadButton, marginBottom: "16px" }}
          onClick={addCustomField}
          disabled={isLocked}
        >
          <MdUpload size={20} />
          Add Custom Text
        </button>
        {inputFields.filter((field) => !field.fieldKey).map((field) => (
          <div
            key={field.id}
            style={{
              ...sidebarStyles.fieldItem,
              ...(field.visible ? sidebarStyles.fieldItemActive : {}),
            }}
          >
            <div
              style={sidebarStyles.fieldHeader}
              onClick={() => {
                if (!isLocked) {
                  if (field.visible) {
                    setExpandedFieldId(expandedFieldId === field.id ? null : field.id)
                    setSelectedFieldId(field.id)
                  } else {
                    toggleFieldVisibility(field.id)
                  }
                }
              }}
            >
              <span
                style={{
                  ...sidebarStyles.fieldIcon,
                  ...(field.visible ? sidebarStyles.fieldIconActive : {}),
                }}
              >
                <FiType size={18} />
              </span>
              <span style={sidebarStyles.fieldLabel}>{field.label}</span>
              <div
                style={{
                  ...sidebarStyles.toggleSwitch,
                  ...(field.visible ? sidebarStyles.toggleSwitchActive : {}),
                }}
                onClick={(e) => {
                  e.stopPropagation()
                  if (!isLocked) {
                    toggleFieldVisibility(field.id)
                  }
                }}
              >
                <div
                  style={{
                    ...sidebarStyles.toggleKnob,
                    ...(field.visible ? sidebarStyles.toggleKnobActive : {}),
                  }}
                />
              </div>
              {field.visible && (
                <>
                  <button
                    style={{
                      marginLeft: "8px",
                      color: "#dc2626",
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                    }}
                    onClick={(e) => {
                      e.stopPropagation()
                      deleteCustomField(field.id)
                    }}
                  >
                    <MdDelete size={20} />
                  </button>
                  <span style={{ marginLeft: "8px", color: "#64748b" }}>
                    {expandedFieldId === field.id ? <MdExpandLess size={24} /> : <MdExpandMore size={24} />}
                  </span>
                </>
              )}
            </div>
            {field.visible && expandedFieldId === field.id && renderFieldDesignPanel(field)}
          </div>
        ))}
      </div>
    </>
  )
  return (
    <div style={mainContainerStyle}>
      <ToastMessage />
      <div style={headerStyle}>
        <div>
          <h1 style={headerTitleStyle}>Badge Designer</h1>
          <p style={headerSubtitleStyle}>Create and customize badge templates for your events</p>
        </div>
        <div>
          <Button className="primary" onClick={()=>{history.push('/events/admin/badge')}}>back</Button>
          </div>
      </div>
      <div style={{ display: "flex", gap: "28px", alignItems: "flex-start" }}>
        <div style={sidebarStyles.container}>
          <div style={sidebarStyles.header}>
            <div style={sidebarStyles.headerTitle}>{badgeTitle}</div>
            <div style={sidebarStyles.headerSubtitle}>
              {isEdit
                ? isLocked
                  ? "Preview mode - Click Edit to modify"
                  : "Editing template"
                : step1Completed
                  ? "Add fields and customize styling"
                  : "Step 1: Upload background image"}
            </div>
          </div>
          <div style={sidebarStyles.tabContainer}>
            <button
              style={{
                ...sidebarStyles.tab,
                ...(activeTab === "background" ? sidebarStyles.tabActive : {}),
              }}
              onClick={() => setActiveTab("background")}
            >
              <MdUpload size={18} />
              Background
            </button>
            <button
              style={{
                ...sidebarStyles.tab,
                ...(activeTab === "fields" ? sidebarStyles.tabActive : {}),
                ...(!step1Completed && !isEdit ? { opacity: 0.5, cursor: "not-allowed" } : {}),
              }}
              onClick={() => {
                if (step1Completed || isEdit) {
                  setActiveTab("fields")
                }
              }}
              disabled={!step1Completed && !isEdit}
            >
              <FiType size={18} />
              Fields
            </button>
          </div>
          <div style={sidebarStyles.scrollableContent}>
            {activeTab === "background" && (
              <>
                <div style={sidebarStyles.section}>
                  <div style={sidebarStyles.sectionTitle}>Template Settings</div>
                  <label style={sidebarStyles.label}>Template Name</label>
                  <input
                    type="text"
                    style={{ ...sidebarStyles.input, marginBottom: "16px" }}
                    value={badgeTitle}
                    onChange={(e) => setBadgeTitle(e.target.value)}
                    disabled={isLocked}
                    placeholder="Enter template name"
                  />
                  <div style={{ display: "flex", gap: "14px" }}>
                    <div style={{ flex: 1 }}>
                      <label style={sidebarStyles.label}>Canvas Size</label>
                      <select
                        style={sidebarStyles.select}
                        value={canvasSize}
                        onChange={(e) => setCanvasSize(e.target.value)}
                        disabled={step1Completed}
                      >
                        <option value="4x6">4x6 inch</option>
                        <option value="3x4">3x4 inch</option>
                        <option value="4x4">4x4 inch</option>
                        <option value="5x7">5x7 inch</option>
                      </select>
                    </div>
                  
                  </div>
                  <div style={{ flex: 1, position: 'relative' }} ref={ticketDropdownRef}>
  <label style={sidebarStyles.label}>Tickets</label>
  <div
    style={{
      ...sidebarStyles.select,
      cursor: isLocked ? 'not-allowed' : 'pointer',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      opacity: isLocked ? 0.6 : 1
    }}
    onClick={() => !isLocked && setIsTicketDropdownOpen(!isTicketDropdownOpen)}
  >
    <span>{getTicketDisplayText()}</span>
    <span style={{ marginLeft: '8px' }}>▼</span>
  </div>
  
  {isTicketDropdownOpen && !isLocked && (
    <div style={{
      position: 'absolute',
      top: '100%',
      left: 0,
      right: 0,
      backgroundColor: '#FFFFFF',
      border: '1px solid #FFFFFF',
      borderRadius: '4px',
      maxHeight: '200px',
      overflowY: 'auto',
      zIndex: 1000,
      marginTop: '4px'
    }}>
      <div
        style={{
          padding: '8px 12px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          backgroundColor: selectedTickets.includes(0) ? '#FFFFFF' : 'transparent'
        }}
        onClick={() => handleTicketToggle(0)}
        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#FFFFFF'}
        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = selectedTickets.includes(0) ? '#FFFFFF' : 'transparent'}
      >
        <input
          type="checkbox"
          checked={selectedTickets.includes(0)}
          onChange={() => {}}
          style={{ cursor: 'pointer' }}
        />
        <span>All Tickets</span>
      </div>
      
      {tickets.map((ticket) => (
        <div
          key={ticket.id}
          style={{
            padding: '8px 12px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            backgroundColor: selectedTickets.includes(ticket.id) ? '#FFFFFF' : 'transparent'
          }}
          onClick={() => handleTicketToggle(ticket.id)}
          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#FFFFFF'}
          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = selectedTickets.includes(ticket.id) ? '#FFFFFF' : 'transparent'}
        >
          <input
            type="checkbox"
            checked={selectedTickets.includes(ticket.id)}
            onChange={() => {}}
            style={{ cursor: 'pointer' }}
          />
          <span>{ticket.ticket_name}</span>
        </div>
      ))}
    </div>
  )}
</div>
                </div>
                {renderBackgroundTab()}
              </>
            )}
            {activeTab === "fields" && (step1Completed || isEdit) && renderFieldsTab()}
          </div>
          {isStep2Enabled && !isLocked && (
            <div style={sidebarStyles.saveButtonContainer}>
              <button
                style={{
                  ...sidebarStyles.saveButton,
                  ...(isEdit ? sidebarStyles.updateButton : {}),
                }}
                onClick={handleFinalSave}
                disabled={isGenerating}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)"
                  e.currentTarget.style.boxShadow = isEdit
                    ? "0 8px 25px rgba(14, 165, 233, 0.4)"
                    : "0 8px 25px rgba(30, 58, 95, 0.4)"
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)"
                  e.currentTarget.style.boxShadow = isEdit
                    ? "0 6px 20px rgba(14, 165, 233, 0.3)"
                    : "0 6px 20px rgba(30, 58, 95, 0.3)"
                }}
              >
                {isGenerating ? (
                  <>
                    <span
                      style={{
                        width: "20px",
                        height: "20px",
                        border: "3px solid rgba(255,255,255,0.3)",
                        borderTopColor: "#fff",
                        borderRadius: "50%",
                        animation: "spin 1s linear infinite",
                      }}
                    />
                    {isEdit ? "Updating..." : "Saving..."}
                  </>
                ) : (
                  <>
                    {isEdit ? <MdEdit size={22} /> : <MdSave size={22} />}
                    {isEdit ? "Update Template" : "Save Template"}
                  </>
                )}
              </button>
              <style>{`
                @keyframes spin {
                  to { transform: rotate(360deg); }
                }
              `}</style>
            </div>
          )}
        </div>
        <div style={canvasContainerStyle}>
          <div
            ref={badgeRef}
            style={badgeCanvasStyle}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
          >
            {!bgPreview && (
              <div style={emptyCanvasStyle}>
                <MdUpload size={56} />
                <p style={{ marginTop: "16px", fontSize: "15px", fontWeight: "500" }}>Upload a background image</p>
              </div>
            )}
{console.log("[v0] Rendering images:", { imageFilesCount: imageFiles.length, step1Completed, isLocked })}
{imageFiles.map((img) => (
  <div
    key={img.id}
    style={{
      position: "absolute",
      left: img.x,
      top: img.y,
      width: img.width,
      height: img.height,
      cursor: isLocked ? "default" : "move",
      borderRadius: "8px",
      overflow: "hidden",
      boxShadow: "0 6px 16px rgba(0,0,0,0.18)",
      pointerEvents: isLocked ? "none" : "auto",
    }}
    onMouseDown={(e) => !isLocked && handleImageMouseDown(e, img.id)}
  >
    <img
      src={img.preview || "/placeholder.svg"}
      alt=""
      style={{ width: "100%", height: "100%", objectFit: "cover", pointerEvents: "none" }}
    />
    {!isLocked && (
      <>
        <button
          className="delete-btn"
          style={{
            position: "absolute",
            top: 8,
            right: 8,
            width: 28,
            height: 28,
            borderRadius: "50%",
            border: "none",
            backgroundColor: "#ef4444",
            color: "#fff",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
          }}
          onClick={(e) => {
            e.stopPropagation()
            deleteImage(img.id)
          }}
        >
          <MdDelete size={16} />
        </button>
        <div
          className="resize-handle"
          style={{
            position: "absolute",
            bottom: 0,
            right: 0,
            width: 20,
            height: 20,
            cursor: "se-resize",
            backgroundColor: "rgba(30, 58, 95, 0.8)",
            borderTopLeftRadius: "6px",
          }}
          onMouseDown={(e) => handleImageResizeDown(e, img.id)}
        />
      </>
    )}
  </div>
))}
            {showPreviewElements &&
              inputFields
                .filter((f) => f.visible)
                .map((field) => (
                  <div
                    key={field.id}
                    style={{
                      position: "absolute",
                      left: field.x,
                      top: field.y,
                      width: field.width,
                      height: field.height,
                      fontSize: field.fontSize,
                      fontFamily: field.fontFamily,
                      fontWeight: field.fontWeight,
                      color: field.color,
                      textAlign: field.textAlign,
                      cursor: isLocked ? "default" : "move",
                      display: "flex",
                      alignItems: field.textAlign === "center" ? "center" : "flex-start",
                      justifyContent:
                        field.textAlign === "center"
                          ? "center"
                          : field.textAlign === "right"
                            ? "flex-end"
                            : "flex-start",
                      border:
                        selectedFieldId === field.id && !isLocked ? "2px dashed #1e3a5f" : "2px dashed transparent",
                      borderRadius: "6px",
                      padding: "4px 8px",
                      backgroundColor:
                        selectedFieldId === field.id && !isLocked ? "rgba(30, 58, 95, 0.08)" : "transparent",
                      transition: "background-color 0.2s, border-color 0.2s",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                    }}
                    onMouseDown={(e) => handleTextMouseDown(e, field.id)}
                  >
                    <span style={{ pointerEvents: "none" }}>{field.fieldKey ? `{{${field.fieldKey}}}` : field.text}</span>
                    {selectedFieldId === field.id && !isLocked && (
                      <div
                        className="resize-handle"
                        style={{
                          position: "absolute",
                          bottom: 0,
                          right: 0,
                          width: 16,
                          height: 16,
                          cursor: "se-resize",
                          backgroundColor: "#1e3a5f",
                          borderTopLeftRadius: "4px",
                        }}
                        onMouseDown={(e) => handleTextResizeDown(e, field.id)}
                      />
                    )}
                  </div>
                ))}
            {showPreviewElements && qrVisible && (qrImage || qrUrl) && (
              <div
                style={{
                  position: "absolute",
                  left: qrPosition.x,
                  top: qrPosition.y,
                  width: qrSize.width,
                  height: qrSize.height,
                  cursor: isLocked ? "default" : "move",
                  borderRadius: "8px",
                  overflow: "hidden",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  border: isDragging ? "2px solid #1e3a5f" : "2px solid transparent",
                }}
                onMouseDown={handleQRMouseDown}
              >
                <img
                  src={qrUrl || qrImage || "/placeholder.svg"}
                  alt="QR Code"
                  style={{ width: "100%", height: "100%", objectFit: "contain", pointerEvents: "none" }}
                />
                {!isLocked && (
                  <div
                    className="resize-handle"
                    style={{
                      position: "absolute",
                      bottom: 0,
                      right: 0,
                      width: 18,
                      height: 18,
                      cursor: "se-resize",
                      backgroundColor: "rgba(30, 58, 95, 0.9)",
                      borderTopLeftRadius: "6px",
                    }}
                    onMouseDown={handleQRResizeDown}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      <Modal
        show={alertModal.show}
        onHide={() => setAlertModal({ ...alertModal, show: false })}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="border-0 pb-0 position-relative">
          <div className="position-absolute start-0 top-50 translate-middle-y ms-4">
            {alertModal.variant === "success" && <i className="icon-check-circle text-success fs-1"></i>}
            {alertModal.variant === "warning" && <i className="icon-alert-triangle text-warning fs-1"></i>}
            {(!alertModal.variant || alertModal.variant === "info") && (
              <i className="icon-info-circle text-info fs-1"></i>
            )}
          </div>
          <Modal.Title className="w-100 text-center pe-5">
            <h5 className="mb-0 fw-semibold">
              {alertModal.variant === "success"
                ? "Success!"
                : alertModal.variant === "warning"
                  ? "Warning"
                  : "Information"}
            </h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-4 pb-5 text-center">
          <p className="mb-0 fs-5 text-muted px-5 lh-lg">{alertModal.message}</p>
        </Modal.Body>
        <Modal.Footer className="border-0 justify-content-center pb-5">
          <Button
            variant={
              alertModal.variant === "success" ? "success" : alertModal.variant === "warning" ? "warning" : "primary"
            }
            size="lg"
            className="px-5 rounded-pill shadow-sm"
            onClick={() => setAlertModal({ ...alertModal, show: false })}
          >
            {alertModal.variant === "success" ? "Great!" : "Got it"}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={confirmModal.show} onHide={() => setConfirmModal({ ...confirmModal, show: false })} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Action</Modal.Title>
        </Modal.Header>
        <Modal.Body>{confirmModal.message}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setConfirmModal({ ...confirmModal, show: false })}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleConfirmModalConfirm}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}
export default Badge